import { defineStore } from "pinia";
import { ref } from "vue";

export type Locale = "nl" | "fr" | "en" | "tr";

export const useLocaleStore = defineStore("localeStore", () => {
  const locale = ref<Locale>("nl");

  const setLocale = (l: Locale) => {
    locale.value = l;
  };

  return { locale, setLocale };
});
